import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import fields from '../json/AssignRoomOfferFields.json';
import useFormChange from 'Hooks/useFormChange';
import { AssignRoomOfferValidation } from 'validation/ValidationRules';
import useFetchFormDataById from 'Hooks/useFetchFormDataById';
import useFormSubmit from 'Hooks/useFormSubmit';
import { getRoomOfferById, UpdateRoomOffer } from 'adminApi/AssignRoomOfferApi/AssignRoomOffer';
import { validateForm } from 'utils/validation';
import { Spinner } from 'react-bootstrap';
import CopyAssignRoomOfferForm from './Components/CopyAssignRoomOfferForm';

const CopyAssignRoomOffer = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues } = useFormChange(initialValues, AssignRoomOfferValidation);

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getRoomOfferById, setValues);

    // Form submit hook
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await UpdateRoomOffer({ id, data: formData });
        },
        (vals) => validateForm(vals, AssignRoomOfferValidation),
        () => navigate(-1),
        "Room updated successfully"
    );
    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
            <CopyAssignRoomOfferForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                loadingFetch={loadingFetch}
                title="Copy Room Offer"
            />
        </>
    );
}

export default CopyAssignRoomOffer